<div class="last-heartbeat-info" [ngClass]="{'error': !!error}" [matTooltip]="error">
  <mat-icon inline>heart_broken</mat-icon>
  <span *ngIf="chargepoint?.lastHeartbeat">
    {{chargepoint?.lastHeartbeat?.toLocaleString()}}
  </span>
  <span *ngIf="!chargepoint?.lastHeartbeat">
    Missing heartbeat
  </span>
</div>